import React from 'react'
import { motion } from 'framer-motion'
import { useTheme, themeStyles } from '../context/ThemeContext'

interface ArabicAnimatedTitleProps {
  text: string
  className?: string
}

const ArabicAnimatedTitle: React.FC<ArabicAnimatedTitleProps> = ({
  text,
  className = '',
}) => {
  const { theme } = useTheme();
  const currentTheme = themeStyles[theme];
  
  return (
    <div className={`flex items-center ${className}`}>
      <motion.h1
        className={`text-4xl md:text-6xl lg:text-8xl font-bold ${currentTheme.text}`}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, type: 'spring', stiffness: 100 }}
      >
        {text}
      </motion.h1>
    </div>
  )
}

export default ArabicAnimatedTitle
